import { OwcHyperlink } from "@one/react";
import { COVER_SHEET_LIST } from "../../constants";
import { DigitalLabLogbookInstrumentModelType } from "../../models/DigitalLabLogbookInstrumentModelType";
import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";
import { replaceEmptyWithHyphen, validateSelection } from "../../utils/helpers/text";
import EquipmentStatusRender from "../log-book/log-book-table/EquipmentStatusRender";
import { THEME } from "@digitallab/grid-common-frontend-components";
import { react18WorkaroundProps } from "../../utils/constants/react18WorkaroundProps";

const REPOSITORY_URL = process.env.REACT_APP_REPOSITORY_URL || "";

export type MapProps = {
  snapShotView: boolean;
  equipmentDetail: DigitalLabLogbookInstrumentModelType;
  gxpReadys: unknown;
};

export const DisplayItemValueDefault = (
  equipmentDetail: DigitalLabLogbookInstrumentModelType,
  coverSheetItem: string
) => replaceEmptyWithHyphen(equipmentDetail[coverSheetItem as keyof DigitalLabLogbookInstrumentModelType]);

export const DisplayStatus = (props: MapProps) => {
  return (
    <EquipmentStatusRender
      value={props.equipmentDetail[COVER_SHEET_LIST.status.key as keyof DigitalLabLogbookInstrumentModelType] as string}
      style={{ height: "inherit" }}
    />
  );
};

export const DisplaySystemStatus = (props: MapProps) => {
  return replaceEmptyWithHyphen(
    props.equipmentDetail[DATA_MODEL_TABLE.systemStatus.key as keyof DigitalLabLogbookInstrumentModelType]
  );
};

export const DisplayGxPStatus = (props: MapProps) => {
  return replaceEmptyWithHyphen(
    validateSelection(props.gxpReadys, {
      key: props.equipmentDetail[DATA_MODEL_TABLE.qualificationStatus.key as keyof DigitalLabLogbookInstrumentModelType]
    })
  );
};

const DocumentationLink = (props: MapProps) => {
  const inventoryId = props.equipmentDetail?.inventoryId || props.equipmentDetail?.id;
  return (
    <OwcHyperlink
      onClick={(event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        if (REPOSITORY_URL) {
          window.open(`${REPOSITORY_URL}/equipmentList/${inventoryId}?action=documentation`, "_blank");
        }
      }}
      style={{ cursor: "pointer" }}
      href={""}
      {...react18WorkaroundProps}
    >
      <strong
        style={{
          fontFamily: THEME["one-typography-font-family"],
          fontWeight: THEME["one-text-font-weight-700"],
          color: THEME["one-color-cobas-blue-600"]
        }}
      >
        View documentation
      </strong>
    </OwcHyperlink>
  );
};

const DisplayConfigurationDetails = (props: MapProps) => (
  <span style={{ whiteSpace: "pre-wrap" }}>
    {replaceEmptyWithHyphen(
      props.equipmentDetail[DATA_MODEL_TABLE.configurationDetails.key as keyof DigitalLabLogbookInstrumentModelType]
    )}
  </span>
);

export const coverSheetValuesComponents = new Map([
  [COVER_SHEET_LIST.currentGxPStatusFromLogs.key, DisplayGxPStatus],
  [COVER_SHEET_LIST.currentSystemStatusFromLogs.key, DisplaySystemStatus],
  [COVER_SHEET_LIST.status.key, DisplayStatus],
  [COVER_SHEET_LIST.checklists.key, DocumentationLink],
  [COVER_SHEET_LIST.configurationDetails.key, DisplayConfigurationDetails]
]);
